'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _reactUtils = require('react-utils');

var _createChainablePropType = require('./createChainablePropType');

var _createChainablePropType2 = _interopRequireDefault(_createChainablePropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDisplayName = function getDisplayName(Component) {
  var component = Component.CoreComponent || Component.WrappedComponent || Component;
  return component.displayName;
};

exports.default = function (component) {
  var propTypes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : component.propTypes;

  (0, _reactUtils.invariant)(!!propTypes, 'passthroughProps: expected propTypes object as second argument, got ' + propTypes);

  var _ref = typeof component === 'function' ? [getDisplayName(component), component] : [component, undefined],
      _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      Component = _ref2[1];

  var validator = function validator() {
    return _react.PropTypes.object.apply(_react.PropTypes, arguments);
  };

  return (0, _createChainablePropType2.default)(validator, 'passthroughProps', {
    Component: Component,
    name: name,
    propTypes: propTypes
  });
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/utils/propTypes/passthroughProps.js
// module id = 90
// module chunks = 0